import React from "react";
import { NavLink, useMatch, useLocation } from "react-router-dom";
import { ListItemIcon, ListItemText, ListItem } from "@mui/material";
import { SidebarNavItemProps } from "./types/SidebarTypes";
import { styled } from '@mui/material/styles';

// Styled ListItem that will be used for active and inactive states
export const StyledListItem = styled(ListItem)(({ theme }) => ({
  transition: 'background-color 0.2s ease',
  
  '&:hover': {
    background: theme.palette.action.hover,
  },
  
  '&.active': {
    background: '#d32f2f', // Red background color
    color: theme.palette.common.white,
    '& .MuiListItemIcon-root': {
      color: theme.palette.common.white,
    },
    "&:hover": {
      background: '#b71c1c', // Darker red on hover
    }
  }
}));

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  text,
  to,
  icon,
  exact,
  isActive: customIsActive,
}) => {
  const location = useLocation();
  const match = useMatch({
    path: exact ? String(to) : `${String(to)}/*`,
    end: !!exact
  });

  const isItemActive = customIsActive 
    ? customIsActive(match !== null, location)
    : match !== null;
  
  return (
    <NavLink 
      to={to}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <StyledListItem className={isItemActive ? "active" : ""}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
      </StyledListItem>
    </NavLink>
  );
}; 